import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';

import { SiteList } from '@/components/MainNav/SiteSelection';
import appStore from 'stores/app';
import history from 'utils/history';

import Anime from '../components/ui/Anime';
import Box from '../components/ui/Box';
import Header from '../components/ui/Header';
import Wrapper from '../components/ui/Wrapper';

export default function SiteSelectionFormLayout() {
  const [sites, setSites] = useState([])

  useEffect(() => {
    if (appStore.site) {
      history.push('/');
    } else {
      appStore.listSites().then(sites => {
        setSites(sites)
      });
    }
  }, []);

  const handleClickSite = site => {
    appStore.setSite(site);
    history.push('/');
  }

  return <>
    <Helmet title="Site Selection" />
    <Anime>
      <Box>
        <Wrapper>
          <Header text='Site selection' />
          <SiteList sites={sites} onSelect={handleClickSite} isLogin />
        </Wrapper>
      </Box>
    </Anime>
  </>
}
